
import { deserialise } from 'kitsu-core'
import ProjectMixin from '@/_mixins/project'
import { getRequest } from '@/plugins/api-axios'
import FormResponse from '@/views/Project/Form/components/formResponse.vue'
import FormResponseMixin from '@/views/Project/ch/mixins/formResponse.mixin'
import FormResponseViewer from '@/views/Project/Form/components/formResponseViewer.vue'
import PrintResponseButton from '@/views/Project/Form/components/printResponseButton.vue'

export default {
    name: 'Respond',
    mixins: [ProjectMixin, FormResponseMixin],
    components: { FormResponse, FormResponseViewer, PrintResponseButton },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            formResponse: null,
            contractorFormResponse: null as any,
            isNotFound: false,
            isSubmitted: false,
        }
    },
    computed: {
        deviceTimeZone() {
            return this.guessTimezone()
        },
        breadcrumbs() {
            return [
                { to: { path: '/' }, text: 'VBIT' },
                { text: this.$t(`fe_contractors['form.heading_formResponse']`) },
            ]
        },
        formResponseExportFilename() {
            if (!this.contractorFormResponse) {
                return ''
            }

            return `${this.contractorFormResponse.form?.data.name}-${
                this.contractorFormResponse.submittedBy?.data.name
            }-${this.formatDate(
                this.contractorFormResponse.submittedAt,
                this.deviceTimeZone,
                'DD.MM.YYYY HH:mm'
            )}`
        },
    },
    async created() {
        try {
            let { data } = await getRequest(
                `${this.formBaseUrl}/formResponses`,
                {},
                {
                    'filter[resource]': this.id,
                    include: 'revision,resource',
                }
            )
            let [formResponse] = deserialise(data).data

            if (!formResponse) throw new Error('Form response not found')

            let res = await getRequest(
                `${this.contractorBaseUrl}/contractorFormResponses/${formResponse.resource.data.id}?include=submittedBy,form`
            )
            this.contractorFormResponse = deserialise(res.data).data
            this.formResponse = formResponse
        } catch (error) {
            this.isNotFound = true
        }
    },
}
